import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Tr, Td, Switch } from "@appcues/component-library";
import moment from "moment";
import Textarea from "components/Common/Forms/Textarea";
import { updateUserEventAndFlushUserEvent } from "actions/userEvents";

class EventRow extends Component {
  static propTypes = {
    userEvent: PropTypes.object.isRequired,
    actions: PropTypes.object
  };

  onChangeEventDescription = e => {
    const {
      userEvent,
      actions: { updateUserEventAndFlushUserEvent }
    } = this.props;

    updateUserEventAndFlushUserEvent(userEvent.id, {
      description: e.target.value
    });
  };

  onChangeShowInUI = showInUI => {
    const {
      userEvent,
      actions: { updateUserEventAndFlushUserEvent }
    } = this.props;

    updateUserEventAndFlushUserEvent(userEvent.id, { showInUI });
  };

  render() {
    const { userEvent } = this.props;

    return (
      <Tr key={`${userEvent.name}-first`}>
        <EventTd style={{ cursor: "pointer" }} onClick={this.toggleExpandedRow}>
          {userEvent.name}
        </EventTd>
        <EventTd>
          <Textarea
            style={{
              minWidth: 260
            }}
            onChange={this.onChangeEventDescription}
            value={userEvent.description}
            placeholder="Enter description"
          />
        </EventTd>
        <EventTd>{moment(new Date(userEvent.lastSeenTs)).format("LL")}</EventTd>
        <EventTd>
          <Switch
            checked={userEvent.showInUI}
            onChange={this.onChangeShowInUI}
          />
        </EventTd>
      </Tr>
    );
  }
}

const EventTd = styled(Td)`
  vertical-align: center;
  padding: 16px;
  word-wrap: break-word;

  &:first-child {
    padding-left: 32px;
  }

  &:last-child {
    padding-right: 32px;
  }
`;

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        updateUserEventAndFlushUserEvent
      },
      dispatch
    )
  };
}

export default connect(null, mapDispatchToProps)(EventRow);
